import { useCallback, useMemo } from "react";
import { useCommercialLegalAffairsBureau } from "@/features/commercialRegistrationReceptionBookFeed/hooks/useCommercialLegalAffairsBureau";

/**
 * 法務局IDから法務局名を解決する関数を返すフック
 */
export const useLegalAffairsBureauName = (): ((
  legalAffairsBureauId?: number
) => string) => {
  const { legalAffairsBureauOptions } = useCommercialLegalAffairsBureau();

  const nameById = useMemo(() => {
    const map = new Map<string, string>();
    legalAffairsBureauOptions.forEach((option) => {
      map.set(option.value, option.label);
    });
    return map;
  }, [legalAffairsBureauOptions]);

  return useCallback(
    (legalAffairsBureauId?: number): string => {
      if (legalAffairsBureauId == null) return "";
      return nameById.get(String(legalAffairsBureauId)) ?? "";
    },
    [nameById]
  );
};
